import prismPeakService from '@/services/prism-peak.service';

const initialState = {
    status: {
        listDocumentsComplete: false,
        getDocumentsComplete: false,
        createDocumentComplete: false,
        deleteDocumentComplete: false,
    },
    documents: {},
    document: [],
    createDocument: {},
    deleteDocument: {}
};

export const prismPeakModule = {
    namespaced: true,
    state: initialState,
    actions: {
        clearDocuments({ commit }) {
            commit('clearDocuments');
        },
        listDocuments({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                prismPeakService.listDocuments(payload.page, payload.limit, payload.filter)
                    .then(documents => {
                        commit('populateDocuments', documents);
                        resolve(documents);
                    })
                    .catch(error => {
                        commit('clearDocuments');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearDocument({ commit }) {
            commit('clearDocument');
        },
        getDocument({ dispatch, commit }, payload) {
            commit('clearDocument');
            return new Promise((resolve, reject) => {
                prismPeakService.getDocument(payload.party, payload.type)
                    .then(document => {
                        commit('populateDocument', document);
                        resolve(document);
                    })
                    .catch(error => {
                        commit('clearDocument');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearCreateDocument({ commit }) {
            commit('clearCreateDocument');
        },
        createDocument({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('clearCreateDocument');
                prismPeakService.createDocument(payload.party, payload.type)
                    .then(createDocument => {
                        commit('populateCreateDocument', createDocument);
                        resolve(createDocument);
                    })
                    .catch(error => {
                        commit('clearCreateDocument');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearDeleteDocument({ commit }) {
            commit('clearDeleteDocument');
        },
        deleteDocument({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('clearDeleteDocument');
                prismPeakService.deleteDocument(payload.party, payload.type)
                    .then(deleteDocument => {
                        commit('populateDeleteDocument', deleteDocument);
                        resolve(deleteDocument);
                    })
                    .catch(error => {
                        commit('clearDeleteDocument');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    })
            });
        }
    },
    mutations: {
        clearDocuments(state) {
            state.status.listDocumentsComplete = false;
            state.documents = {};
        },
        populateDocuments(state, documents) {
            state.status.listDocumentsComplete = true;
            state.documents = documents;
        },
        clearDocument(state) {
            state.status.listDocumentComplete = false;
            state.document = [];
        },
        populateDocument(state, document) {
            state.status.listDocumentComplete = true;
            state.document.push(document);
        },
        clearCreateDocument(state) {
            state.status.createDocumentComplete = false;
            state.createDocument = {};
        },
        populateCreateDocument(state, createDocument) {
            state.status.listDocumentsComplete = true;
            state.createDocument = createDocument;
        },
        clearDeleteDocument(state) {
            state.status.deleteDocumentComplete = false;
            state.deleteDocument = {};
        },
        populateDeleteDocument(state, deleteDocument) {
            state.status.deleteDocumentComplete = true;
            state.deleteDocument = deleteDocument;
        }
    }
};
